export const MAP={
  'user.add:dd':'/weioslwe/ee'
}



// WEBPACK FOOTER //
// ./src/data/permission.js